import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Nav({ project }) {
  const nav = useNavigate();
  return (
    <header className="nav">
      <div className="nav-brand">
        <Link to="/" className="ws">The Workshop<span className="accent">.</span></Link>
        {project && (
          <>
            <span className="sep">/</span>
            <Link to={`/project/${project._id}`} className="where">
              <span className="colormark" style={{ '--m': project.colorMark, background: project.colorMark }} />
              {project.title}
            </Link>
          </>
        )}
      </div>
      <div className="nav-mid">
        <button className="nav-search" onClick={() => window.dispatchEvent(new CustomEvent('openCmdK'))}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
          <span>Search this {project ? 'project' : 'workshop'}…</span>
          <span className="kbd">⌘K</span>
        </button>
      </div>
      <div className="nav-right">
        <button className="nav-init" onClick={() => window.dispatchEvent(new CustomEvent('openInit'))}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M12 5v14M5 12h14" /></svg>
          {project ? 'Brief / ask the room' : 'New project'}
        </button>
        <button className="btn ghost small" onClick={async () => {
          await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' });
          location.reload();
        }}>Logout</button>
      </div>
    </header>
  );
}
